<template>
  <div
    v-if="banner && isUserNonLoyalist"
    :key="forceRerenderKey"
    class="loyalList"
    v-html="banner"
  />
</template>

<script setup>
import useLoyalList from '@composables/useLoyalList';
import { useLoyalty } from '@composables/useLoyalty';

const { banner, forceRerenderKey } = useLoyalList();
const { isUserNonLoyalist } = useLoyalty();
</script>

<style lang="scss">
  @import "~settingSCSS";
  .loyalList {
    .purple {
      color: $loyalty-1-color;
    }
    .pink {
      color: $highlight-color;
    }
  }
</style>
